import React, { useContext } from 'react'
import { Domain, MessageConst } from 'enums'
import StreamSymbol from 'enums/StreamSymbol'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { compactNumberFormatter } from 'utils/numberFormatterUtil'
import {
  StyledFooterContainer,
  StyledFooterLeft,
  StyledFooterRight,
  StyledFooterItem,
  StyledFooterItemValue,
  StyledFooterItemIcon
} from './index.css'
import FooterTooltip from '../FooterTooltip'
import MediaCardContext from '../mediaCardContext'
import { MetricsMapping, IconMapping } from '../constant'

const Footer = () => {
  const { domain, mode, footer, isError, dataStream } = useContext(MediaCardContext)
  const isVoc = dataStream === StreamSymbol.VOC
  const isPodcast = dataStream === StreamSymbol.PODCAST
  // eslint-disable-next-line no-nested-ternary
  const source = isVoc ? StreamSymbol.VOC : isPodcast ? StreamSymbol.PODCAST : domain!

  return (
    <StyledFooterContainer mode={mode} displayBorder={isError}>
      <StyledFooterLeft>{MetricsMapping[source].getIcon(12, mode)}</StyledFooterLeft>
      <FooterTooltip>
        <StyledFooterRight mode={mode}>
          {MetricsMapping[source].metrics
            .filter((item) => {
              if (domain === Domain.TWITTER && footer.get(item) === undefined) {
                return false
              }
              return true
            })
            .map((item, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <StyledFooterItem key={`${idx}-${domain}-${item}`}>
                <StyledFooterItemIcon>
                  {IconMapping[item!].getIcon(12, mode, sys[mode].text.placeholder, domain)}
                </StyledFooterItemIcon>
                <StyledFooterItemValue mode={mode}>
                  {footer.get(item) !== (undefined || null) && typeof footer.get(item) === 'number'
                    ? compactNumberFormatter({
                        value: footer.get(item)!,
                        precise: dataStream !== StreamSymbol.PODCAST
                      })
                    : MessageConst.EM_DASH}
                </StyledFooterItemValue>
              </StyledFooterItem>
            ))}
        </StyledFooterRight>
      </FooterTooltip>
    </StyledFooterContainer>
  )
}

export default Footer
